export enum ETemperatureControlType {
  Unknown = -1,
  Chiller = 0,
  Peltier = 1,
}

export const temperatureControlTypeDropdown = [
  ETemperatureControlType[ETemperatureControlType.Unknown],
  ETemperatureControlType[ETemperatureControlType.Chiller],
  ETemperatureControlType[ETemperatureControlType.Peltier]
];
